import React from "react";
import styled from "styled-components";
import Dinero from 'dinero.js';
const Price = styled.div `
  color: ${props => props.color.hex};
  border: 1px solid ${props => props.color.hex};
  background: ${props => props.backgroundPrice.hex};
  border-radius: 10px;
  padding-left: 5px;
  padding-right: 5px;
`;
export const PriceComponent = ({ price, color }) => {
    return React.createElement(Price, { color: color }, `${Dinero({ amount: parseInt(price, 10) }).toFormat('0.0')} €`);
};
